import {EquipmentPlain} from '@hconnect/common'
import moment from 'moment-timezone'

import {MachineSentryActionDto, TaskSource} from '../types'
import {
  EditMachineSentryAction,
  EditMachineSentryActionDto,
  MachineSentryActionFormValues
} from '../types/machine-sentry-actions.types'

export const mapToMachineSentryActionFormValues = (
  data: MachineSentryActionDto,
  timezone: string
): MachineSentryActionFormValues => {
  return {
    ...data,
    dueDate: data.dueDate ? moment.tz(data.dueDate, timezone).toISOString() : null,
    ...(data.assignees && {
      assignees: data.assignees
    }),
    source: TaskSource.MACHINE_SENTRY_ACTIONS,
    functionalLocation: data.machineSentryProperties.functionalLocation,
    machineSentryProcessStage: data.machineSentryProperties.processStage,
    processStage: data.processStage,
    ...(data.equipment && {
      equipment: {
        equipment: data.equipment,
        ...(data.processStage && {processStage: {processStep: data.processStage}}),
        ...(data.mainEquipment && {mainEquipment: data.mainEquipment})
      } as EquipmentPlain
    })
  }
}

const mapToEditMachineSentryActionDto = (
  formValues: MachineSentryActionFormValues
): EditMachineSentryActionDto => {
  const {assignees, mainEquipment, equipment, dueDate, ...rest} = formValues
  const actionDtoObject = {
    ...rest,
    dueDate: dueDate ?? null, // Validation ensures dueDate is required before submission
    equipmentId: equipment?.equipment.id,
    equipmentIdType: equipment?.equipment.idType,
    equipmentText: equipment?.equipment.text,
    mainEquipmentId: mainEquipment?.id,
    mainEquipmentIdType: mainEquipment?.idType,
    mainEquipmentText: mainEquipment?.text,
    assignees: assignees.map((assignee) => assignee.id)
  }
  return actionDtoObject
}

export const mapToMachineSentryAction = (
  formValues: MachineSentryActionFormValues,
  id: string,
  plantUpmId: string
): EditMachineSentryAction => {
  return {
    ...mapToEditMachineSentryActionDto(formValues),
    id,
    plantUpmId
  }
}
